import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, navigate } from "@reach/router";
import Auth from "Api/Auth";
import moment from "moment";
import Api from "Api/Api";
import { adminRoutes, investorsRoutes } from "Routes";
function mapStateToProps(state) {
  return {
    section: state.section,
    notifications: state.notifications,
    showSidebar: state.showSidebar,
    showSearchWidgetIn: state.showSearchWidgetIn,
  };
}
class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unreadNoti: 0,
      notifications: [],
    };
    this.showStartupIn = ["Startups", "Dashboard"];
    this.logout = () => {
      Auth.LogoutUser();
      navigate("/");
    };
    this.toggleNavbar = () => {
      this.props.dispatch({
        type: "showSidebar",
        payload: !this.props.showSidebar,
      });
    };
    this.clicked = (data) => {
      var routes = Auth.decodedToken().moderator
        ? adminRoutes
        : investorsRoutes;
      var to = routes.filter((route) => {
        return route.notificationType === data.type;
      })[0].to;

      if (!data.seen) {
        Api.markAsRead({
          notificationIDs: [data.id],
        }).then((response) => {
          if (response.status === 200) {
            this.props.dispatch({
              type: "MarkAsRead",
              payload: [data.id],
            });
          }
        });
      }
      navigate(to, { state: { highlightData: data.json } });
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (props.showSidebar) {
      document.querySelector("html").classList.add("nav-open");
    } else {
      document.querySelector("html").classList.remove("nav-open");
    }
    var unread = (props.notifications || []).filter((noti) => {
      return !noti.seen;
    }).length;
    return {
      unreadNoti: unread,
      notifications: props.notifications || [],
    };
  }

  render() {
    return (
      <nav
        className={`navbar navbar-expand-lg  ${
          this.props.authenticated
            ? "navbar-transparent navbar-absolute fixed-top"
            : ""
        }`}
      >
        <div className="container-fluid">
          <div className="navbar-wrapper">
            <Link to="/" className="navbar-brand text-capitalize">
              {this.props.authenticated ? (
                this.props.section === "" ? (
                  "Dashboard"
                ) : (
                  this.props.section
                )
              ) : (
                <img
                  className="brandLogo"
                  src="https://venturegarage.in/wp-content/uploads/2017/08/Venture-garage-logo-png.png"
                  alt="Venture garage logo"
                />
              )}
            </Link>
          </div>
          <button
            className={`navbar-toggler ${
              this.props.showSidebar ? "toggled" : ""
            }`}
            type="button"
            data-toggle="collapse"
            aria-controls="navigation-index"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={this.toggleNavbar}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="navbar-toggler-icon icon-bar"></span>
            <span className="navbar-toggler-icon icon-bar"></span>
            <span className="navbar-toggler-icon icon-bar"></span>
          </button>
          {this.props.authenticated ? (
            <div className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link"
                    href="http://example.com"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="material-icons">notifications</i>
                    {this.state.unreadNoti ? (
                      <span className="notification">
                        {this.state.unreadNoti}
                      </span>
                    ) : null}
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="navbarDropdownMenuLink"
                    style={{ width: 300 }}
                  >
                    {this.state.notifications.length ? (
                      this.state.notifications.slice(0, 5).map((noti) => {
                        return (
                          <span
                            className="dropdown-item notifications"
                            key={noti.id}
                            style={{ display: "block" }}
                            onClick={() => {
                              this.clicked(noti);
                            }}
                          >
                            <div className="notification-text">
                              {noti.seen ? null : (
                                <i className="fa fa-circle readStatus"></i>
                              )}
                              {noti.title}
                            </div>
                            <div className="notification-time">
                              {moment(noti.created).fromNow()}
                            </div>
                          </span>
                        );
                      })
                    ) : (
                      <p style={{ margin: "0px 10px" }} className="text-center">
                        <span>No notifications</span>
                        <span style={{ display: "block" }}>
                          <i className="im im-bell-off"></i>
                        </span>
                      </p>
                    )}
                    {this.state.notifications.length ? (
                      <Link
                        className="dropdown-item text-center see-all-btn"
                        to="notifications"
                      >
                        See All
                      </Link>
                    ) : null}
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link"
                    href="#pablo"
                    id="navbarDropdownProfile"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="material-icons">person</i>
                    <p className="d-lg-none d-md-block">Account</p>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="navbarDropdownProfile"
                  >
                    {Auth.decodedToken().moderator ? null : (
                      <Link to="profile" className="dropdown-item">
                        Profile
                      </Link>
                    )}

                    <a className="dropdown-item" href onClick={this.logout}>
                      Log out
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          ) : (
            <div className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav">
                <li className="nav-item" style={{ marginRight: 10 }}>
                  <Link to="/login" className="btn btn-primary">
                    Login
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>
    );
  }
}
export default connect(mapStateToProps)(NavBar);
